import { ChangeEvent, PropsWithChildren, useCallback, useId } from 'react';
import styles from './selectableHeader.module.scss';
import { PermissionAware } from 'core';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';

export type SelectableHeaderProps = {
  selectedCount: number;
  allSelected: boolean;
  currentPageSelected: boolean;
  selectPermissionAware?: PermissionAware;
  onSelectPage?: (checked: boolean) => void;
};

export const SelectableHeader: React.FC<
  SelectableHeaderProps & PropsWithChildren
> = ({
  selectedCount,
  allSelected,
  currentPageSelected,
  children,
  selectPermissionAware,
  onSelectPage
}) => {
  const checkboxId = useId();
  const onCheckboxChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onSelectPage && onSelectPage(e.target.checked);
    },
    [onSelectPage]
  );

  const renderCheckbox = useCallback(
    () => (
      <>
        <input
          type='checkbox'
          checked={currentPageSelected}
          ref={(el) =>
            el && (el.indeterminate = !allSelected && selectedCount > 0)
          }
          onChange={onCheckboxChange}
          id={checkboxId}
        />
        <label htmlFor={checkboxId} />
      </>
    ),
    [
      currentPageSelected,
      allSelected,
      selectedCount,
      checkboxId,
      onCheckboxChange
    ]
  );

  return (
    <div className={styles.selectableHeader} key={allSelected.toString()}>
      {onSelectPage ? (
        selectPermissionAware ? (
          <PermissionChecker permissionAware={selectPermissionAware}>
            {renderCheckbox()}
          </PermissionChecker>
        ) : (
          renderCheckbox()
        )
      ) : null}
      {children}
    </div>
  );
};
